import './assets/reset.css'
import './assets/tokens.css'

import Vue from 'vue'

import store from './store'
import router from './router'

import App from './App.vue'

Vue.config.productionTip = false

/*
	Real viewport height. On mobile, 100vh includes the browser chrome, so
	full-height layouts overflow under the address/nav bars. We publish a --vh
	custom property (1% of the actual innerHeight) and use calc(var(--vh) * 100)
	for full-height surfaces — no dependency, no reliance on dvh units.
*/
function setViewportHeight() {

	document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px')

}

setViewportHeight()
window.addEventListener('resize', setViewportHeight)
window.addEventListener('orientationchange', setViewportHeight)

// auto-register shared chrome components (<app-foo>) from components/common:
// Mark, Wordmark, Topbar, Foot, Btn, Input. The play/* components are local to
// the screens that compose them (imported directly), not globally registered.
var commonComponents = require.context('./components/common', true, /[A-Z]\w+\.(vue|js)$/)

commonComponents.keys().forEach(function(filename) {

	var componentConfig = commonComponents(filename)
	var componentName = 'app' + filename.replace(/\//g, '-').replace('.vue', '').replace('.', '').toLowerCase()

	Vue.component(
		componentName,
		componentConfig.default
	)

})

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')

// PWA: register the app-shell service worker. Production only — in dev it would
// cache HMR chunks and fight hot reload.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {

	window.addEventListener('load', function() {

		navigator.serviceWorker.register((process.env.BASE_URL || '/') + 'sw.js').catch(function() {})

	})

}
